module.exports = __webpack_public_path__ + "static/img/banner_solutions_web.21227a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_web.png
// module id = 7WD1
// module chunks = 10